/** Валидная денежная сумма: неотрицательное целое число копеек. */
export const isMoney = (amount: number): boolean => Number.isSafeInteger(amount) && amount >= 0;

/** Преобразует операторский ввод рублей (`1 250,50`) в целые копейки. */
export const parseRublesToKopecks = (value: string): number | null => {
  const normalized = value.trim().replaceAll(' ', '').replace(',', '.');
  const match = /^(\d+)(?:\.(\d{0,2}))?$/.exec(normalized);

  if (!match?.[1]) {
    return null;
  }

  const rubles = Number(match[1]);
  const kopecks = Number((match[2] ?? '').padEnd(2, '0'));
  const amount = rubles * 100 + kopecks;

  return isMoney(amount) ? amount : null;
};

/** Формат для заполнения денежного input без символа валюты. */
export const formatKopecksForInput = (amount: number): string => {
  if (!isMoney(amount)) {
    throw new RangeError('Сумма должна быть неотрицательным целым числом копеек');
  }

  const rubles = Math.floor(amount / 100);
  const kopecks = amount % 100;

  return kopecks === 0 ? String(rubles) : `${rubles},${String(kopecks).padStart(2, '0')}`;
};
